interface ItemNumberProps {
	value: number;
}

export const ItemNumber: React.FC<ItemNumberProps> = ({ value }) => {
	return <span className="w-6 h-6 text-sm inline-flex items-center justify-center font-bold text-gray-600  bg-gray-200 rounded-full">
		{value}
	</span>

};
